/** Strict 8-4-4-4-12 hex GUID — the one check every OEP path uses before an ID enters a filter or a lookup. */
const OEP_GUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export function IsOEPGuid(value: string): boolean {
    return OEP_GUID.test(value);
}

/** The value itself when it is a GUID; throws otherwise (for IDs interpolated into SQL/ExtraFilter text). */
export function AssertOEPGuid(value: string, label = 'value'): string {
    if (!OEP_GUID.test(value)) throw new Error(`${label} is not a GUID: ${value}`);
    return value;
}
